import { Props, TriggerBtnProps } from '@models/types/genieask.type';
import { ErrorBoundary } from 'react-error-boundary';
import React, { ReactNode, Suspense } from 'react';
const WorksheetMinichat = React.lazy(() => import('genieask/mini-chat'));

const ButtonDisabled = ({
  buttonComponent,
}: {
  buttonComponent: (triggerBtn: TriggerBtnProps) => ReactNode;
}) => {
  return <>{buttonComponent({} as TriggerBtnProps)}</>;
};

const WorksheetMinichatPage = (props: Props) => {
  return (
    <div id="genieask_worksheet_minichat" className="w-fit">
      {
        <ErrorBoundary
          fallback={<ButtonDisabled buttonComponent={props.trigger} />}
        >
          <Suspense>
            <WorksheetMinichat
              worksheet={props.worksheet}
              trigger={props.trigger}
              initialScreen={props.initialScreen}
              className="!z-[101] max-lg:!hidden" // the `z-index` value will be changed if the image preview is opened. the settings is in `GenieaskPreviewImage` component
              fullChatUrl={props.fullChatUrl}
              align={props.align}
              alignOffset={props.alignOffset}
              isDisabled={props.isDisabled}
              unreadMessage={props.unreadMessage}
            />
          </Suspense>
        </ErrorBoundary>
      }
    </div>
  );
};

export default WorksheetMinichatPage;
